import React from 'react';

const Card: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = '' }) => {
  return (
    <div className={`rounded-lg px-6 py-4 bg-white w-full ${className}`}>
      {children}
    </div>
  );
};

export default Card; 